import { render, staticRenderFns } from "./GoogleRecaptchaKeys.vue?vue&type=template&id=73f54cda&scoped=true&lang=pug&"
import script from "./GoogleRecaptchaKeys.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptchaKeys.vue?vue&type=script&lang=js&"
import style0 from "./GoogleRecaptchaKeys.vue?vue&type=style&index=0&id=73f54cda&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f54cda",
  null
  
)

/* custom blocks */
import block0 from "./GoogleRecaptchaKeys.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports